module.exports = __webpack_public_path__ + "static/media/slackEmoji9.0858c018.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/slackEmoji9.gif
// module id = 43
// module chunks = 0